import * as React from 'react'
import { PopperUnstyledOwnProps, PopperUnstyled } from './PopperUnstyled'
import { SxProps } from '../sx'

export type PopperProps = Omit<PopperUnstyledOwnProps, 'direction'> & {
  sx?: SxProps
  id?: string
}

export const Popper = React.forwardRef<HTMLDivElement, PopperProps>(
  function Popper(props, ref) {
    const { slots, slotProps, ...other } = props

    const RootComponent = slots?.root

    const { classes, ...otherSlotProps } = slotProps?.root ?? {}

    return (
      <PopperUnstyled
        direction={'ltr'}
        slots={{ root: RootComponent }}
        slotProps={{ root: otherSlotProps }}
        classes={classes}
        {...other}
        ref={ref}
      />
    )
  }
)
